import { number } from 'prop-types';
import React from 'react';
import { GoPencil } from 'react-icons/go';

import EntityLabel from '../../../generic/EntityLabel';

function BookingEntryModalLink({ id }) {
  return (
    <>
      <EntityLabel id={id} resourceType="bookingEntry" />
      <span className="text-muted font-weight-light ml-2 small va-tb">
        <GoPencil />
      </span>
    </>
  );
}

BookingEntryModalLink.propTypes = { id: number.isRequired };

export default BookingEntryModalLink;
